import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Wenhao"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_569_8444)"><path d="M7.99992 14.6667C9.84085 14.6667 11.5075 13.9205 12.714 12.7141C13.9204 11.5076 14.6666 9.84097 14.6666 8.00004C14.6666 6.15911 13.9204 4.49244 12.714 3.28599C11.5075 2.07957 9.84085 1.33337 7.99992 1.33337C6.15899 1.33337 4.49232 2.07957 3.28587 3.28599C2.07945 4.49244 1.33325 6.15911 1.33325 8.00004C1.33325 9.84097 2.07945 11.5076 3.28587 12.7141C4.49232 13.9205 6.15899 14.6667 7.99992 14.6667Z" stroke="#0FBD81" stroke-width="1.33333"></path><path d="M8 9.54159V8.20825C9.10457 8.20825 10 7.31282 10 6.20825C10 5.10369 9.10457 4.20825 8 4.20825C6.89543 4.20825 6 5.10369 6 6.20825" stroke="#0FBD81" stroke-width="1.33333" stroke-linecap="square"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.00008 12.5415C8.46031 12.5415 8.83341 12.1684 8.83341 11.7082C8.83341 11.248 8.46031 10.8749 8.00008 10.8749C7.53985 10.8749 7.16675 11.248 7.16675 11.7082C7.16675 12.1684 7.53985 12.5415 8.00008 12.5415Z" fill="#0FBD81"></path></g><defs><clipPath id="clip0_569_8444"><rect width="16" height="16" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var wenhao = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { wenhao as default };
